<template>
    <div class="accordion" id="additional-payment-options-parent">
        <div class="accordion-item">
            <h2 class="accordion-header" id="additional-payment-options">
                <button class="accordion-button" type="button" @click="$helper.toggleAccordion(($store.state.inClientAdmin ? 7 : 5), true);">
                    {{ $helper.trans('Additional_payment_options') }}
                </button>
            </h2>

            <div id="additional-payment-options-content" class="accordion-collapse collapse" aria-labelledby="additional-payment-options" data-parent="#additional-payment-options-parent">
                <div class="accordion-body">
                    <div class="major-payment-methods-radios-container">
                        <label for="payment-prepaid" class="custom-radio-wrap">
                            {{ $helper.trans('Myself_now') }}
                            <input type="radio" v-model="$store.state.majorPaymentType" value="prepaid" id="payment-prepaid">
                            <span class="checkmark"></span>
                        </label>                                       
                        <label for="payment-all" class="custom-radio-wrap">
                            {{ $helper.trans('Other_types') }}
                            <input type="radio" v-model="$store.state.majorPaymentType" value="all" id="payment-all">
                            <span class="checkmark"></span>
                        </label>
                    </div>

                    <div class="additional-payment-options-wrap w-100 mt-0" v-show="$store.state.majorPaymentType === 'all'">
                        <div class="additional-payment-options-block w-100 mt-0 mb-0 pb-0" style="border-bottom: none !important;">
                            <div class="column-option w-50 differentPaymentInformation_payer_input">
                                <ul class="list-payment">
                                    <li>
                                        <input type="radio" v-model="$store.state.differentPaymentInformation.payer" value="sender" id="payment-customer">
                                        <label for="payment-customer" class="payment-name-option option-btn-1">{{ isImport ? $helper.trans('Add_to_my_account') :  $helper.trans('Sender_pays') }}</label>
                                    </li>
                                    <li v-if="!isImport">
                                        <input type="radio" v-model="$store.state.differentPaymentInformation.payer" value="receiver" id="payment-receiver">
                                        <label for="payment-receiver" class="payment-name-option option-btn-2">{{ $helper.trans('Receiver_pays') }}</label>
                                    </li>
                                    <li>
                                        <input type="radio" v-model="$store.state.differentPaymentInformation.payer" value="third_party" id="payment-third-country">
                                        <label for="payment-third-country" class="payment-name-option option-btn-3">{{ $helper.trans('Third_party_pays') }}</label>
                                    </li>
                                </ul>
                            </div>
                            <div class="column-option w-50">
                                <div class="all-payments-inputs-container">
                                    <div class="mb-3 w-100 px-2 px-md-4" v-show="$store.state.differentPaymentInformation.payer === 'sender'">
                                        <input type="text" readonly :value="$store.state.$siteSettings['client_number']" class="input-big w-100"/>
                                    </div>
                                    <div class="mb-3 w-100 px-2 px-md-4" v-show="$store.state.differentPaymentInformation.payer !== 'sender'">
                                        <input type="text" @blur="$store.state.differentPaymentInformation.payerCode = customReplace($store.state.differentPaymentInformation.payerCode, ' ', '')" v-model="$store.state.differentPaymentInformation.payerCode" :placeholder="'* '+$helper.trans('Payer_code')" class="input-big w-100 differentPaymentInformation_payerCode_input"/>
                                    </div>
                                    <div class="mb-3 w-100 px-2 px-md-4" v-show="$store.state.differentPaymentInformation.payer !== 'sender'">
                                        <input type="text" @blur="$store.state.differentPaymentInformation.payerPostCode = customReplace($store.state.differentPaymentInformation.payerPostCode, ' ', '')" v-model="$store.state.differentPaymentInformation.payerPostCode" :placeholder="'* '+$helper.trans('Payer_post_code')" class="input-big w-100 differentPaymentInformation_payerPostCode_input"/>
                                    </div>                            
                                    <div class="w-100 px-2 px-md-4" v-show="$store.state.differentPaymentInformation.payer === 'third_party'">
                                        <select2-component
                                            :values="countries"
                                            :placeholder="'* '+$helper.trans('Country')"
                                            :noLang="true"
                                            :notKeyed="true"
                                            classes="input-big differentPaymentInformation_payerCountry_input"
                                            v-model="$store.state.differentPaymentInformation.payerCountry"
                                            dropDownClass="select2_customization"
                                        ></select2-component> 
                                    </div>                            
                                </div>
                            </div>
                        </div>
                        <div class="additional-payment-options-block mb-0 pb-1 pt-4 mt-4" style="border-top: 1px solid #ddd7d0; border-bottom: none !important;" v-if="!$helper.insideEu() && !$store.state.otherDeliveryInformation.isDocuments && !this.$helper.isToIreland()">
                            <div class="row w-100">
                                <div class="col-12">
                                    <label class="strong-label">{{ $helper.trans('Import_tax_payer') }}:</label>
                                </div>
                                <div class="col-12 col-md-6 mb-3">
                                    <select2-component
                                        ref="importTaxPayerComponent"
                                        :values="importPayerValues"
                                        :noEmptyOption="true"
                                        :noLang="true"
                                        :useIndexes="true"
                                        classes="input-big select-style-ups differentPaymentInformation_importPayer_input"
                                        v-model="$store.state.differentPaymentInformation.importPayer"
                                    ></select2-component>
                                </div>
                                <div class="col-12 col-md-6 mb-3">
                                    <input type="text" @blur="customReplace($store.state.differentPaymentInformation.importPayerCode, ' ', '')" :readonly="$store.state.differentPaymentInformation.importPayer === 'sender'" v-model="$store.state.differentPaymentInformation.importPayerCode" :placeholder="'* ' + $helper.trans('Payer_code')" class="input-big w-100"/>
                                </div>
                                <div class="col-12 col-md-6 mb-3" v-show="$store.state.differentPaymentInformation.importPayer !== 'sender'">
                                    <input type="text" @blur="$store.state.differentPaymentInformation.importPayerPostCode = customReplace($store.state.differentPaymentInformation.importPayerPostCode, ' ', '')" v-model="$store.state.differentPaymentInformation.importPayerPostCode" :placeholder="($store.state.differentPaymentInformation.importPayer === 'third_party' ? '* ' : '') + $helper.trans('Payer_post_code')" class="input-big w-100 differentPaymentInformation_importPayerPostCode_input"/>
                                </div>
                                <div class="col-12 col-md-6 mb-3" v-show="$store.state.differentPaymentInformation.importPayer === 'third_party'">
                                    <select2-component
                                        :values="countries"
                                        :placeholder="'* '+$helper.trans('Country')"
                                        :noLang="true"
                                        :notKeyed="true"
                                        classes="input-big differentPaymentInformation_importPayerCountry_input"
                                        v-model="$store.state.differentPaymentInformation.importPayerCountry"
                                        dropDownClass="select2_customization"
                                    ></select2-component> 
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="link-block" v-if="$store.state.inClientAdmin">
                        <button type="button" @click="nextStep($store.state.inClientAdmin ? 6 : 4);" class="link link-left">{{ isImport ? $helper.trans('Label_presenting') : $helper.trans('Call_carrier') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,    
    data: function(){
        return {
            countries: {},
        };
    },
    created: function(){
        let vueThis = this;
    
        if(vueThis.isImport && vueThis.$store.state.differentPaymentInformation.importPayer === 'receiver'){
            vueThis.$store.state.differentPaymentInformation.importPayer = 'sender';
        }

        vueThis.countries = {};
        $.each(vueThis.$store.state.countriesList, function(index, element){         
            vueThis.countries[index] = {
                'key': element.country_code.toLowerCase(),
                'text': element.title,
            };
        }); 
    },
    methods:{
        customReplace(string, replaceFrom, replaceTo) {
            if (string === null || string === undefined || string == '') {
                return string;
            }
            return string.replaceAll(replaceFrom, replaceTo);
        },
        nextStep(nextStep){             
            this.$helper.toggleAccordion(nextStep, true);        
        },
        setPayerCode(payer) {
            if(payer === 'receiver'){
                this.$store.state.differentPaymentInformation.payerCode = this.$store.state.to.ups_account_number;
                this.$store.state.differentPaymentInformation.payerPostCode = this.$store.state.to.postCode;
            } else {
                this.$store.state.differentPaymentInformation.payerCode = '';
                this.$store.state.differentPaymentInformation.payerPostCode = '';
            }
        },
        setImportTaxPayerCode(importTaxPayer) {
            switch(importTaxPayer) {
                case "receiver":
                    this.$store.state.differentPaymentInformation.importPayerCode = this.$store.state.to.ups_account_number;
                    break;
                case "sender":
                    this.$store.state.differentPaymentInformation.importPayerCode = this.$store.state.$siteSettings['client_number'];
                    break;
                default:
                    this.$store.state.differentPaymentInformation.importPayerCode = '';
            }
        }
    },
    computed: {
        isImport(){
            return this.$store.state.to.country === 'lt';
        },
        importPayerValues(){
            let values = {};

            values['sender'] = this.isImport ? this.$helper.trans('Add_to_my_account') : this.$helper.trans('Sender_pays');
            if(!this.isImport){
                values['receiver'] = this.$helper.trans('Receiver');
            } else if(this.$store.state.differentPaymentInformation.importPayer === 'receiver'){
                this.$store.state.differentPaymentInformation.importPayer = 'sender';
            }
            values['third_party'] = this.$helper.trans('Third_party');

            if(this.$refs.importTaxPayerComponent !== undefined && this.isImport && !this.$store.state.returnedBackFromPayment){
                this.$refs.importTaxPayerComponent.updateValues(values);
            }
   
            return values;
        }
    },
    watch: {
        '$store.state.differentPaymentInformation.importPayer': function(newValue){
            this.setImportTaxPayerCode(newValue)
        },
        '$store.state.otherDeliveryInformation': {
            handler(newValue) {
                this.$store.state.checkOutSteps.fifth = false;
            },
            deep: true
        },
        '$store.state.differentPaymentInformation.payer': {
            handler(newValue) {
                this.setPayerCode(newValue);
            },
        }
    },
}
</script>
